module.exports = __webpack_public_path__ + "cda8ce1eb709ef68e76cbce8537ea2ef.pdf";